import axios from "axios";

const API = axios.create({

  baseURL:
    process.env.REACT_APP_API_URL || "/",

  timeout: 20000,

  headers: {

    "Content-Type":
      "application/json",

  },

});

API.interceptors.request.use((request) => {
  console.debug(
    "API request:",
    request.method,
    request.baseURL + request.url
  );
  return request;
});

const formatApiError = (err) => {
  if (!err || typeof err !== "object") {
    return "An unknown API error occurred.";
  }

  if (err.code === "ECONNABORTED" || /timeout/i.test(err.message)) {
    return (
      "The backend request timed out. " +
      "Please make sure the backend server is running and restart the frontend."
    );
  }

  if (err.message === "Network Error") {
    return (
      "Cannot reach the backend. " +
      "Please make sure the backend server is running and accessible."
    );
  }

  if (err.response) {
    const status = err.response.status;

    if (status === 503) {
      return (
        "Backend is currently unavailable. " +
        "Start MongoDB and restart the backend server."
      );
    }
    if (status === 404) {
      return "Requested API endpoint was not found on the backend.";
    }
    if (status >= 500) {
      return "A server error occurred. Check the backend logs for details.";
    }
    if (err.response.data && err.response.data.error) {
      return err.response.data.error;
    }
  }

  return err.message || "An unexpected API error occurred.";
};

API.interceptors.response.use(
  (response) => response,
  (error) => {
    error.message = formatApiError(error);
    return Promise.reject(error);
  }
);

// =====================================================
// PRODUCTS
// =====================================================

export const fetchProducts =
  () => API.get("/products");

// =====================================================
// HISTORICAL
// =====================================================

export const fetchHistorical =
  () =>
    API.get(
      "/historical-products"
    );

// =====================================================
// KPI SUMMARY
// =====================================================

export const fetchKpiSummary =
  () =>
    API.get(
      "/kpi-summary"
    );

// =====================================================
// COMPETITIVE MATRIX
// =====================================================

export const fetchCompetitiveMatrix =
  () =>
    API.get(
      "/competitive-matrix"
    );

// =====================================================
// DASHBOARD SUMMARY
// =====================================================

export const fetchDashboardSummary =
  () =>
    API.get(
      "/dashboard-summary"
    );

// =====================================================
// CATEGORY INSIGHTS
// =====================================================

export const fetchCategoryInsights =
  () =>
    API.get(
      "/category-insights"
    );

// =====================================================
// PLATFORM SUMMARY
// =====================================================

export const fetchPlatformSummary =
  () =>
    API.get(
      "/platform-summary"
    );

// =====================================================
// AI QUERY
// =====================================================

export const askAI = (
  data
) =>
  API.post(
    "/ask-ai",
    data
  );

export { formatApiError };
export default API;